import { render, staticRenderFns } from "./SectionSubHeader.vue?vue&type=template&id=35cd435e&scoped=true&"
var script = {}
import style0 from "./SectionSubHeader.vue?vue&type=style&index=0&id=35cd435e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd435e",
  null
  
)

export default component.exports